import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { AlertComponent } from "../alert/alert.component";

@Component({
  selector: "app-public-component",
  standalone: true,
  imports: [RouterOutlet, AlertComponent],
  templateUrl: "./public.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicComponent {}
